import { getTranslatedText } from '@nile/components';

export const getTechniciansGroupsImportFields = (intl, currentProduct) => {
  const techniciansGroupsFields = [
    {
      label: 'entityAttribute.techGroup.name',
      key: 'name',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'attribute.description',
      key: 'description',
      type: 'string'
    },
    {
      label: 'entityAttribute.technician.emails',
      key: 'technicians',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          // prettier-ignore
          // multiple email regex
          regex: '^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}[;\\s]*)+$',
          errorMessage: 'domain.validation.emailAddress'
        }
      ],
      description: getTranslatedText(intl, 'dromo.description.multipleEmails')
    }
  ];
  if (currentProduct == 'MSP') {
    techniciansGroupsFields.push({
      label: 'admin.Techniciangroup.Clients',
      key: 'clients',
      type: 'string'
    });
  } else if (currentProduct == 'IT') {
    techniciansGroupsFields.push({
      label: 'admin.serviceCatalog.sites',
      key: 'sites',
      type: 'string'
    });
  }

  return techniciansGroupsFields;
};
